import React from "react";
import {
  Container,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle"; // Import an icon for bullet points

function Home() {
  return (
    <Container maxWidth="md" sx={{ textAlign: "center", mt: 0 }}>
      {/* Description Section */}
      <Typography variant="h4" gutterBottom>
        Welcome to Minerva Chess Analysis
      </Typography>
      <Typography variant="body1" paragraph>
        Minerva is designed to enhance your chess learning experience by
        providing insightful narratives and analysis. Our goal is to bridge the
        gap between raw chess engine evaluations and practical understanding,
        making learning intuitive and enjoyable.
      </Typography>

      {/* Image with Text Section */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "flex-start",
          mt: 4,
        }}
      >
        <Box sx={{ flex: 1, paddingRight: { md: 2 } }}>
          {/* Image Box */}
          <img
            src={`${process.env.PUBLIC_URL}/img/homepage1.png`} // Replace with your image path
            alt="Minerva Illustration"
            style={{ width: "100%", borderRadius: "8px" }} // Full width on smaller screens
          />
        </Box>
        <Box sx={{ flex: 1, textAlign: "center", mt: { xs: 2, md: 0 } }}>
          <Typography variant="body1">
            Minerva offers a clean and simple interface that makes navigating
            the platform a breeze. Whether you're just starting out or you're a
            seasoned chess player, our design helps you learn and improve your
            skills effortlessly.
          </Typography>
        </Box>
      </Box>

      {/* Features Section */}
      <Box sx={{ mt: 4, textAlign: "left" }}>
        <Typography variant="body1" sx={{ pb: 2 }}>
          Here are some features of Minerva:
        </Typography>
        <List sx={{ pb: 2 }}>
          <ListItem sx={{ p: 0 }}>
            <ListItemIcon>
              <CheckCircleIcon />
            </ListItemIcon>
            <ListItemText
              primary="Top Engine Lines"
              secondary="Get the best recommended moves and evaluations."
            />
          </ListItem>

          <ListItem sx={{ p: 0 }}>
            <ListItemIcon>
              <CheckCircleIcon />
            </ListItemIcon>
            <ListItemText
              primary="Opening Name"
              secondary="See the opening name or identify transpositions."
            />
          </ListItem>

          <ListItem sx={{ p: 0 }}>
            <ListItemIcon>
              <CheckCircleIcon />
            </ListItemIcon>
            <ListItemText
              primary="Move Categories"
              secondary="Understand move quality: Book, Best, Inaccuracy, Blunder."
            />
          </ListItem>

          <ListItem sx={{ p: 0 }}>
            <ListItemIcon>
              <CheckCircleIcon />
            </ListItemIcon>
            <ListItemText
              primary="Piece Threats"
              secondary="Learn what your pieces are attacking."
            />
          </ListItem>

          <ListItem sx={{ p: 0 }}>
            <ListItemIcon>
              <CheckCircleIcon />
            </ListItemIcon>
            <ListItemText
              primary="Tactical Motifs"
              secondary="Identify tactics like Pins, Forks, and Skewers."
            />
          </ListItem>

          <ListItem sx={{ p: 0 }}>
            <ListItemIcon>
              <CheckCircleIcon />
            </ListItemIcon>
            <ListItemText
              primary="Long-Term Plans"
              secondary="Explore strategies like Kingside Attacks and Exchange Sacrifices."
            />
          </ListItem>
        </List>
      </Box>
    </Container>
  );
}

export default Home;
